import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from 'react-router-dom';

import TopButton from "components/topbutton/TopButton";
import * as EgovNet from 'api/fetch';
import Pagination from 'components/Pagination';

import "styles/scss/Nnews.scss";
import waitImage from "images/business/waitImage.jpg";

//소식-----------------------------------------------------------------
const  Announcements = ({activeTab, search}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchCondition, setSearchCondition] = useState(location.state?.searchCondition || { pageIndex: 1, searchWrd: '' });
    const [listTag, setListTag] = useState([]);
    const [paginationInfo, setPaginationInfo] = useState({});
    const [cnt, setCnt] = useState('');
    
    const retrieveList = useCallback((condition) => {
        const retrieveListURL = '/api/announ' + EgovNet.getQueryString(condition);
        const requestOptions = {
            method: "GET",
            headers: {
                'Content-type': 'application/json',
            }
        };        
        EgovNet.requestFetch(retrieveListURL,
            requestOptions,
            (resp) => {
                let mutListTag = [];

                setPaginationInfo(resp.result.paginationInfo);
                setCnt(resp.result.paginationInfo.totalRecordCount); // 총 게시물 수 업데이트

                resp.result.resultList.forEach(function (item, index) {
                    if (index === 0) mutListTag = [];
                    mutListTag.push(
                        <li className="box" key={index} onClick={() => handleAnnouncementsClick(item.pstId)}>
                            <ul className="box-con">
                                <li className="con-name-media">{item.ctgryNm}</li>
                                <li className="box-con-tit">{item.pstTtl}</li>
                                {/* 썸네일이 있으면 썸네일을 없으면 내용을 보여주기 */}
                                {item.thumbnailUrl ? (
                                <li className="box-con-img-box">
                                    <img src={item.thumbnailUrl} alt="썸네일" className="thumbnail" />
                                </li>
                                ) : (
                                <li className="box-con-txt">
                                    <div dangerouslySetInnerHTML={{ __html: item.pstCn }} />
                                </li>
                                )}
                                <li className="box-con-day">
                                    <span>{formatDate(item.regDt)}</span>
                                    <span>조회수 : <span>{item.pstInqCnt}</span></span>
                                </li>
                            </ul>
                        </li>
                    );
                });

                // 자료가 6개 이하일때 빈칸 만들어 넣기
                const emptySlots = 6 - resp.result.resultList.length;
                for (let i = 0; i < emptySlots; i++) {
                    mutListTag.push(
                        <li className="box empty" key={`empty-${i}`}>
                            <ul className="box-con">
                                <li className=""></li>
                                <li className=""></li>
                                <li className="box-con-img-box">
                                    <img src={waitImage} alt='빈이미지'/>                                    
                                </li>
                                <li className=""></li>
                            </ul>
                        </li>
                    );
                }
                setListTag(mutListTag);
            },
            (resp) => {
                console.log("err response : ", resp);
            }
        );
    });

     // 공지사항 클릭 시 이동하는 함수
     const handleAnnouncementsClick = (pstId) => {

        // 클릭한 게시글 조회수 증가
        const retrieveListURL = `/api/view/${pstId}`;
        const requestOptions = {
            method: "POST",
            headers: {
                'Content-type': 'application/json',
            }
        };
        EgovNet.requestFetch(retrieveListURL,
            requestOptions,
            (resp) => {
                // 소식
                navigate(`/news/${pstId}`, { state: { activeTab } });
            }
        );
    };
    
    useEffect(() => {
        setSearchCondition({...searchCondition, searchWrd: search, pageIndex: 1 }); // 검색 조건 업데이트
    }, [search]);

    useEffect(() => {
        retrieveList(searchCondition);
    }, [searchCondition]);

    const handlePageMove = () => {
        const pageInput = document.getElementById("pageInput");
        const pageNumber = parseInt(pageInput.value, 6);

        if (!isNaN(pageNumber) && pageNumber > 0 && pageNumber <= paginationInfo.totalPageCount) {
            setSearchCondition({ ...searchCondition, pageIndex: pageNumber, searchWrd: search });
        } else {
            alert("유효한 페이지 번호를 입력하세요.");
        }
    };

    // 날짜 연월일 시:분 형식으로 변경하는 함수
    const formatDate = (dateString) => {
        if(!dateString) return "-"; // null 값 처리
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    };

    const [pageInput, setPageInput] = useState(searchCondition.pageIndex);

    return (
        <div>
            <TopButton />
            <ul className="box-group">
                {listTag}
            </ul>

            <div className="pagination-group">
                <div>총{cnt}건</div>
                <div className="pagination">
                    <Pagination pagination={paginationInfo} moveToPage={passedPage => {
                            setSearchCondition({ ...searchCondition, pageIndex: passedPage, searchWrd: search})
                            setPageInput(passedPage);
                        }}
                    />
                </div>
                <div className="pageInfo">
                    <input type="text"
                        id="pageInput"
                        value={pageInput}
                        min="1"
                        max={paginationInfo.totalPageCount}
                        onChange={e => {
                            const value = e.target.value.replace(/[^0-9]/g, "");
                            e.target.value = value;
                        }}
                    />
                    <span>/ {paginationInfo.totalPageCount}</span>
                    <button onClick={handlePageMove}>이동</button>
                </div>
            </div>
        </div>
    );
};

const PressRelease = ({activeTab, search}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchCondition, setSearchCondition] = useState(location.state?.searchCondition || { pageIndex: 1, searchWrd: ''});
    const [listTag, setListTag] = useState([]);
    const [paginationInfo, setPaginationInfo] = useState({});
    const [cnt, setCnt] = useState('');
    
    const retrieveList = useCallback((condition) => {
        const retrieveListURL = '/api/release' + EgovNet.getQueryString(condition);
        const requestOptions = {
            method: "GET",
            headers: {
                'Content-type': 'application/json',
            }
        };        
        EgovNet.requestFetch(retrieveListURL,
            requestOptions,
            (resp) => {
                let mutListTag = [];

                setPaginationInfo(resp.result.paginationInfo);
                setCnt(resp.result.paginationInfo.totalRecordCount); // 총 게시물 수 업데이트           
                               
                resp.result.resultList.forEach(function (item, index) {
                    if (index === 0) mutListTag = [];
                    mutListTag.push(
                        <li className="box" key={index} onClick={() => handlePressReleaseClick(item.pstId, item.lnkgAddr)}>
                            <ul className="box-con">
                                <li className="con-name-media">{item.ctgryNm}</li>
                                <li className="box-con-tit">{item.pstTtl}</li>
                               {/* 썸네일이 있으면 썸네일을 없으면 내용을 보여주기 */}
                               {item.thumbnailUrl ? (
                                <li className="box-con-img-box">
                                    <img src={item.thumbnailUrl} alt="썸네일" className="thumbnail" />
                                </li>
                                ) : (
                                <li className="box-con-txt">
                                    <div dangerouslySetInnerHTML={{ __html: item.pstCn }} />
                                </li>
                                )}
                                <li className="box-con-day">
                                    <span>{formatDate(item.regDt)}</span>
                                    <span>조회수 : <span>{item.pstInqCnt}</span></span>
                                </li>
                            </ul>
                        </li>
                    );
                });

                // 자료가 6개 이하일때 빈칸 만들어 넣기
                const emptySlots = 6 - resp.result.resultList.length;
                for (let i = 0; i < emptySlots; i++) {
                    mutListTag.push(
                        <li className="box empty" key={`empty-${i}`}>
                            <ul className="box-con">
                                <li className=""></li>
                                <li className=""></li>
                                <li className="box-con-img-box">
                                    <img src={waitImage} alt='빈이미지'/>                 
                                </li>
                                <li className=""></li>
                            </ul>
                        </li>
                    );
                }
                setListTag(mutListTag);
            },
            (resp) => {
                console.log("err response : ", resp);
            }
        );
    });

     // 공지사항 클릭 시 이동하는 함수
     const handlePressReleaseClick = (pstId, lnkgAddr) => {

        // 클릭한 게시글 조회수 증가
        const retrieveListURL = `/api/view/${pstId}`;
        const requestOptions = {
            method: "POST",
            headers: {
                'Content-type': 'application/json',
            }
        };
        EgovNet.requestFetch(retrieveListURL,
            requestOptions,
            (resp) => {
                if (!lnkgAddr.startsWith("http://") && !lnkgAddr.startsWith("https://")) {
                    lnkgAddr = "http://" + lnkgAddr; // 또는 원하는 기본 도메인 추가
                }
                window.open(lnkgAddr, "_blank");
            }
        );
    };

    useEffect(() => {
        setSearchCondition((prev) => ({ ...prev, searchWrd: search, pageIndex: 1 })); // 검색 조건 업데이트
    }, [search]);

    useEffect(() => {
        retrieveList(searchCondition);
    }, [searchCondition]);

    const handlePageMove = () => {
        const pageInput = document.getElementById("pageInput");
        const pageNumber = parseInt(pageInput.value, 6);

        if (!isNaN(pageNumber) && pageNumber > 0 && pageNumber <= paginationInfo.totalPageCount) {
            setSearchCondition({ ...searchCondition, pageIndex: pageNumber, searchWrd: search });
        } else {
            alert("유효한 페이지 번호를 입력하세요.");
        }
    };

    // 날짜 연월일 시:분 형식으로 변경하는 함수
    const formatDate = (dateString) => {
        if(!dateString) return "-"; // null 값 처리
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    };

    const [pageInput, setPageInput] = useState(searchCondition.pageIndex);

    return (
        <div>
            <TopButton />
            <ul className="box-group">
                {listTag}
            </ul>

            <div className="pagination-group">
                <div>총{cnt}건</div>
                <div className="pagination">
                    <Pagination pagination={paginationInfo} moveToPage={passedPage => {
                            setSearchCondition({ ...searchCondition, pageIndex: passedPage, searchWrd: search })
                            setPageInput(passedPage);
                        }}
                    />
                </div>
                <div className="pageInfo">
                    <input type="text"
                        id="pageInput"
                        value={pageInput}
                        min="1"
                        max={paginationInfo.totalPageCount}
                        onChange={e => {
                            const value = e.target.value.replace(/[^0-9]/g, "");
                            setPageInput(value); // 상태 업데이트
                        }}
                    />
                    <span>/ {paginationInfo.totalPageCount}</span>
                    <button onClick={handlePageMove}>이동</button>
                </div>
            </div>
        </div>
    );
};




//갤러리----------------------------------------------------
const Gallery = ({activeTab, search}) => {
    const navigate = useNavigate();
    const location = useLocation(); 
    const [searchCondition, setSearchCondition] = useState(location.state?.searchCondition || { pageIndex: 1, searchWrd: ''});
    const [listTag, setListTag] = useState([]);
    const [paginationInfo, setPaginationInfo] = useState({});
    const [cnt, setCnt] = useState('');

    // 공지사항 클릭 시 이동하는 함수
    const handleGalleryClick = (pstId) => {        
        // 클릭한 게시글 조회수 증가
        const retrieveListURL = `/api/view/${pstId}`;
        const requestOptions = {
            method: "POST",
            headers: {
                'Content-type': 'application/json',
            }
        };
        EgovNet.requestFetch(retrieveListURL,
            requestOptions,
            (resp) => {
                navigate(`/news/${pstId}`, { state: { activeTab } });
            }
        );
    };

    useEffect(() => {
        setSearchCondition((prev) => ({ ...prev, searchWrd: search, pageIndex: 1 })); // 검색 조건 업데이트
    }, [search]);

    useEffect(() => {
        retrieveList(searchCondition);
    }, [searchCondition]);

    // 날짜 연월일 시:분 형식으로 변경하는 함수
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}`;
    };

    const retrieveList = useCallback((condition) => {
        const retrieveListURL = '/api/gallery' + EgovNet.getQueryString(condition);
        const requestOptions = {
            method: "GET",
            headers: {
                'Content-type': 'application/json',
            }
        };        
        EgovNet.requestFetch(retrieveListURL,
            requestOptions,
            (resp) => {
                let mutListTag = [];

                setPaginationInfo(resp.result.paginationInfo);
                setCnt(resp.result.paginationInfo.totalRecordCount); // 총 게시물 수 업데이트

                resp.result.resultList.forEach(function (item, index) {
                    if (index === 0) mutListTag = [];
                    mutListTag.push(
                        <li className="box" key={item.pstId} onClick={() => handleGalleryClick(item.pstId)}>
                            <ul className="box-con">
                                <li className="con-name-media">{item.ctgryNm}</li>
                                <li className="box-con-tit">{item.pstTtl}</li>
                                {/* 썸네일이 있으면 썸네일을 없으면 내용을 보여주기 */}
                                {item.thumbnailUrl ? (
                                <li className="box-con-img-box">
                                    <img src={item.thumbnailUrl} alt="썸네일" className="thumbnail" />
                                </li>
                                ) : (
                                <li className="box-con-txt">
                                    <div dangerouslySetInnerHTML={{ __html: item.pstCn }} />
                                </li>
                                )}
                                <li className="box-con-day">
                                    <span>{formatDate(item.regDt)}</span>
                                    <span>조회수 : <span>{item.pstInqCnt}</span></span>
                                </li>
                            </ul>
                        </li>
                    );
                });

                // 자료가 6개 이하일때 빈칸 만들어 넣기
                const emptySlots = 6 - resp.result.resultList.length;
                for (let i = 0; i < emptySlots; i++) {
                    mutListTag.push(
                        <li className="box empty" key={`empty-${i}`}>
                            <ul className="box-con">
                                <li className=""></li>
                                <li className=""></li>
                                <li className="box-con-img-box">
                                    <img src={waitImage} alt='빈이미지'/> 
                                </li>
                                <li className=""></li>
                            </ul>
                        </li>
                    );
                }
                setListTag(mutListTag);
            },
            (resp) => {
                console.log("err response : ", resp);
            }
        );
    });    

    const handlePageMove = () => {
        const pageInput = document.getElementById("pageInput");
        const pageNumber = parseInt(pageInput.value, 6);

        if (!isNaN(pageNumber) && pageNumber > 0 && pageNumber <= paginationInfo.totalPageCount) {
            setSearchCondition({ ...searchCondition, pageIndex: pageNumber });
        } else {
            alert("유효한 페이지 번호를 입력하세요.");
        }
    };

    const [pageInput, setPageInput] = useState(searchCondition.pageIndex);

    return(
        <div>
            <ul className="box-group">
                {listTag}
            </ul>
            <div className="pagination-group">
                <div>총{cnt}건</div>
                <div className="pagination">
                    <Pagination pagination={paginationInfo} moveToPage={passedPage => {
                            setSearchCondition({ ...searchCondition, pageIndex: passedPage, searchWrd: search })
                            setPageInput(passedPage);
                        }}
                    />
                </div>
                <div className="pageInfo">
                    <input type="text"
                        id="pageInput"
                        value={pageInput}
                        min="1"
                        max={paginationInfo.totalPageCount}
                        onChange={e => {
                            const value = e.target.value.replace(/[^0-9]/g, ""); // 숫자만 허용
                            setPageInput(value); // 상태 업데이트
                        }}
                    />
                    <span>/ {paginationInfo.totalPageCount}</span>
                    <button onClick={handlePageMove}>이동</button>
                </div>
            </div>
        </div>
    );
};

function News() {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(location.state?.activeTab || 0);
    const tabs = ["소식", "보도자료", "갤러리"];

    const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
    const [search, setSearch] = useState('');
    const [searchCondition, setSearchCondition] = useState(location.state?.searchCondition || { pageIndex: 1, searchWrd: "" });
    const wrdRef = useRef(null);

    const handleSearch = () => {
        const searchWord = wrdRef.current?.value.trim(); // 검색어 가져오기
        if (searchWord) {
            setSearch(searchWord); // 검색어 상태 업데이트
        } else {
            alert("검색어를 입력해주세요.");
        }
    };

    const handleReset = () => {
        wrdRef.current.value = '';
        setSearchCondition({ ...searchCondition, pageIndex: 1, searchWrd: '' });
    };

    // activeTab 변경 시 검색어와 페이지 값 초기화
    useEffect(() => {
        setSearch(''); // 검색어 초기화
        setSearchCondition({ pageIndex: 1, searchWrd: '' }); // 페이지 값 초기화
        if (wrdRef.current) {
            wrdRef.current.value = ''; // 검색 입력 필드 초기화
        }
    }, [activeTab]);

    return (
        <>
        <div className="new">
            <div className="news-background">
                <h1>N 소식</h1>
                <p>[ 소식 / 보도자료 / 갤러리 ]</p>
                {/* 브레드크럼 */}
                <div className="breadcrumb-box container">
                <nav className="breadcrumb">
                <ul>
                <li className="home-icon">
                    <Link to="/">
                        <span className="home"></span>
                    </Link>
                </li>                
                <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                        N소식
                    <span className="dropdown-icon">
                    {isCompanyDropdownOpen ? "▲" : "▼"}
                    </span>
                    {isCompanyDropdownOpen && (
                        <ul className="dropdown-menu">
                        <li>
                            <Link to="/about">회사소개</Link>
                        </li>
                        <li>
                            <Link to="/business">비즈니스</Link>
                        </li>
                        <li>
                            <Link to="/news">N소식</Link>
                        </li>
                        <li>
                            <Link to="/recruitment">인재채용</Link>
                        </li>
                        </ul>
                    )}
                    </li>
                </ul>
                </nav>

                <div className="mobile">
                    <ul>
                    <li className="home-icon">
                        <Link to="/">
                            <span className="home"></span>
                        </Link>
                    </li>
                    <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                        N소식
                        <span className="dropdown-icon">
                        {isCompanyDropdownOpen ? "▲" : "▼"}
                        </span>
                        {isCompanyDropdownOpen && (
                        <ul className="dropdown-menu">
                            <li>
                                <Link to="/about">회사소개</Link>
                            </li>
                            <li>
                                <Link to="/business">비즈니스</Link>
                            </li>
                            <li>
                                <Link to="/news">N소식</Link>
                            </li>
                            <li>
                                <Link to="/recruitment">인재채용</Link>
                            </li>
                            </ul>
                        )}
                        </li>
                    </ul>
                </div>
                </div>
            </div>

            <div className="container news-contents">
                <div className="tabs-container02">
                <div className="tabAndNews">
                <div className="tabs">
                  {tabs.map((tab, index) => (
                      <button
                      key={index}
                      className={activeTab === index ? "tab active" : "tab"}
                      onClick={() => setActiveTab(index)}
                      >
                      {tab}
                      </button>
                  ))}
                  </div>
                  <div className="NnewSearch-box">
                        <input type="text" className="search-input form-control" placeholder="검색어를 입력하세요."
                            name="searchWrd" id="searchWrd" title="검색어"
                            ref={wrdRef}
                            onChange={e => {
                                wrdRef.current.value = e.target.value;
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearch(); // 엔터 키 입력 시 검색 실행
                                }
                            }}
                        />
                        <button className="search-button btn">
                            <span className="search-img" onClick={handleSearch}></span>
                        </button>
                        <span className="search-line"></span>
                        <button className="reset-btn btn">
                            <span className="reset-img" onClick={handleReset}></span>
                        </button>
                  </div>
              </div>
            <div className="tab-content">
                {activeTab === 0 && <Announcements activeTab={activeTab} search={search} />}
                {activeTab === 1 && <PressRelease activeTab={activeTab} search={search} />}
                {activeTab === 2 && <Gallery activeTab={activeTab} search={search} />}
            </div>
            </div>
        </div>
    </div>
    </>
    );
}
export default News;